import React from 'react';
import { useTranslation } from 'react-i18next';

const SupportOnlyBadge = () => {
    const { t } = useTranslation('customer');
    return (
        <div className="absolute top-0 right-6 rounded-b px-3 py-1 text-sm font-medium text-content-white dark:text-content-black bg-surface-accent-strong-default">
            {t('supportOnlyBadge')}
        </div>
    );
};

export default SupportOnlyBadge;
